import React, { Component } from 'react';
import { Meteor } from 'meteor/meteor';
import { get, isEqual, isNil, isEmpty } from 'lodash';
import PropTypes from 'prop-types';

import { featureGetZoom, featurePoint2LatLng } from '../../../modules/geojson-utilities';

import LeafletMap from '../../components/LeafletMap';

let addDefaultBaseMap;
let addOnlineBaseMap;
let drawCustomButtons;
let drawListItems;
let getMapCenter;

class MapContainerLayersList extends Component {
  state = {
    boundingBox: get(this, 'props.filterOptions.location.boundingBox', [[], []]),
    clientModulesReady: false,
    isLeafletMapLoaded: get(this, 'layersListMapComponent.current.state.isMapLoaded', false),
    isLayersListMapLoaded: false
  };

  layersListMapComponent = React.createRef();

  layersListMap = null;

  componentDidMount() {
    const { clientModulesReady } = this.state;
    if (!clientModulesReady) {
      this.loadClientModules();
    }
  }

  async componentDidUpdate(prevProps, prevState) {
    const {
      layerList,
      filterOptions,
      highlightedLayerId,
      defaultBaseMap,
      userControlSetting
    } = this.props;
    const {
      boundingBox,
      clientModulesReady,
      isLeafletMapLoaded,
      isLayersListMapLoaded
    } = this.state;
    const {
      layerList: prevLayerList,
      filterOptions: prevFilterOptions,
      highlightedLayerId: prevHighlightedLayerId,
      defaultBaseMap: prevDefaultBaseMap
    } = prevProps;
    const { boundingBox: prevBoundingBox } = prevState;

    if (clientModulesReady && isLeafletMapLoaded && !isLayersListMapLoaded) {
      await this.initializeMap();
    }

    if (isLayersListMapLoaded) {
      if (!isEmpty(defaultBaseMap) && !isEqual(prevDefaultBaseMap, defaultBaseMap)) {
        await addDefaultBaseMap({
          defaultBaseMap,
          leafletMap: this.layersListMap,
          isUpdate: true
        });
      }
      if (
        !isEqual(layerList, prevLayerList) ||
        !isEqual(highlightedLayerId, prevHighlightedLayerId) ||
        !isEqual(filterOptions, prevFilterOptions)
      ) {
        this.listItemsLayer = drawListItems({
          leafletMap: this.layersListMap,
          listItems: layerList,
          listItemsLayer: this.listItemsLayer,
          defaultLocation: userControlSetting.defaultMapCenter,
          itemCollectionName: 'layers',
          isUpdate: true,
          highlightedItemId: highlightedLayerId
        });
      }

      if (
        get(filterOptions, 'location.filterOn', false) &&
        (!isEqual(boundingBox, prevBoundingBox) || !isEqual(filterOptions, prevFilterOptions))
      ) {
        filterOptions.location.changeBoundingBox(boundingBox);
      }
    }
  }

  initializeMap = async () => {
    const {
      defaultBaseMap,
      filterOptions,
      highlightedLayerId,
      layerList,
      userControlSetting
    } = this.props;

    this.layersListMap = get(this, 'layersListMapComponent.current.leafletMap');
    this.layersListMap.setView(
      featurePoint2LatLng(getMapCenter({ location: userControlSetting.defaultMapCenter })),
      featureGetZoom(userControlSetting.defaultMapCenter)
    );

    if (isEmpty(defaultBaseMap)) {
      addOnlineBaseMap(this.layersListMap);
    } else {
      await addDefaultBaseMap({
        defaultBaseMap,
        leafletMap: this.layersListMap
      });
    }

    this.listItemsLayer = drawListItems({
      leafletMap: this.layersListMap,
      listItems: layerList,
      listItemsLayer: this.listItemsLayer,
      defaultLocation: userControlSetting.defaultMapCenter,
      itemCollectionName: 'layers',
      highlightedItemId: highlightedLayerId
    });

    drawCustomButtons({
      map: {
        selectedButtons: {
          Attribution: true,
          Home: true,
          QRCode: false,
          Scale: true,
          Search: false,
          Title: true,
          Zoom: true
        },
        mapLocation: userControlSetting.defaultMapCenter,
        name: 'Layers'
      },
      leafletMap: this.layersListMap
    });

    this.setState({ isLayersListMapLoaded: true });

    if (!isNil(get(filterOptions, 'location.changeBoundingBox'))) {
      this.updateMapBounds();
      this.layersListMap.on('move zoomend', () => this.updateMapBounds());
    }
  };

  updateMapState = newState => this.setState({ isLeafletMapLoaded: newState });

  async loadClientModules() {
    if (Meteor.isClient) {
      ({
        addDefaultBaseMap,
        addOnlineBaseMap,
        drawCustomButtons,
        drawListItems,
        getMapCenter
      } = await import('../../../modules/leaflet-operations'));
      this.setState({ clientModulesReady: true });
    }
  }

  updateMapBounds() {
    const bounds = this.layersListMap.getBounds();
    const newBoundingBox = [
      [bounds.getWest(), bounds.getSouth()],
      [bounds.getEast(), bounds.getNorth()]
    ];
    this.setState({ boundingBox: newBoundingBox });
  }

  render() {
    const { deployEnv } = this.props;
    return (
      <LeafletMap
        ref={this.layersListMapComponent}
        deployEnv={deployEnv}
        headerType="4"
        mapId="layersListMap"
        updateMapState={this.updateMapState}
      />
    );
  }
}

MapContainerLayersList.propTypes = {
  layerList: PropTypes.array.isRequired,
  deployEnv: PropTypes.string.isRequired,
  filterOptions: PropTypes.object.isRequired,
  highlightedLayerId: PropTypes.string.isRequired,
  defaultBaseMap: PropTypes.object.isRequired,
  userControlSetting: PropTypes.object.isRequired
};

export default MapContainerLayersList;
